import CSVReader from "react-csv-reader";
export const FileUpload = ({ onUpload, fileIndex }) => {
    const handleCSVUpload = (data) => {
        onUpload(data, fileIndex);
    };
    return (<div>
      <CSVReader onFileLoaded={handleCSVUpload}/>
    </div>);
};
